import { render } from "./FeaturedCourses.vue?vue&type=template&id=76223862"
import script from "./FeaturedCourses.vue?vue&type=script&lang=js"
export * from "./FeaturedCourses.vue?vue&type=script&lang=js"

import "./FeaturedCourses.vue?vue&type=style&index=0&id=76223862&lang=scss"
script.render = render

export default script